/**
 * DS-internal hook : les badges d'une séance, à l'heure qu'il est.
 *
 * La règle est pure (`sessionBadges`) ; ce crochet lui donne l'horloge. Elle ne tourne que tant que
 * l'heure peut changer ce que la séance montre (`isSessionClockLive` : le jour même, jusqu'à sa
 * fin) — c'est elle qui fait passer « Aujourd'hui · dans 3 min » à « En cours », puis l'éteint.
 *
 * Toute surface qui montre une séance passe par lui : elle rend `badges` à `<LiveStatusBadges>`
 * (`null` : aucun badge, pas de rangée à poser), et lit `now` si elle a autre chose à dater — le
 * bouton « Rejoindre » de la carte de la prochaine séance.
 */
import { sessionBadges } from "../../ports/primary/ui/formatters/liveSessionBadgesFormatter"
import { isSessionClockLive } from "../../ports/primary/ui/formatters/liveSessionFormatter"
import { type UILiveSession, type UILiveSessionBadges } from "../../ports/primary/ui/types"
import { useMinuteClock } from "./useMinuteClock"

export function useSessionBadges(
    session: Pick<UILiveSession, "date" | "duration" | "statuses">,
    options?: Parameters<typeof sessionBadges>[2]
): { badges: UILiveSessionBadges | null; now: number } {
    const now = useMinuteClock(isSessionClockLive(session))
    return { badges: sessionBadges(session, now, options), now }
}
